export enum DrawingEvent {
  CHANGE_VECTOR_LAYER,
  ACTIVATE_DRAWING_TOOL,
  DRAWING_CONFIG_CHANGED,
  SNAPPING_CONFIG_CHANGED
}
